import { createProfileService } from '@shared/api'
import { makeRequest } from 'src/helpers/request'
import type { GoogleProfileInfo } from 'src/modules/user/types/profile.types'
import { authorizedHttpClient } from './http-client'

export const ProfileService = {
  ...createProfileService(authorizedHttpClient, import.meta.env.VITE_API_URL),

  getGoogleProfile: (): Promise<GoogleProfileInfo> => {
    return makeRequest('https://www.googleapis.com/oauth2/v1/userinfo?alt=json', 'get')
  },
}
